// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB-_bg3TLRFEqOyJ6DV8CYoeiji7ur12Gc",
    authDomain: "organize-ant-develop.firebaseapp.com",
    databaseURL: "https://organize-ant-develop.firebaseio.com",
    projectId: "organize-ant-develop",
    storageBucket: "organize-ant-develop.appspot.com",
    messagingSenderId: "148189502789",
    appId: "1:148189502789:web:332ac08f41d50b7f"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
 